import { IController } from 'angular';

export class MetricsTextInputRowCtrl implements IController {
  public max;

  // bindings
  public metrics;
  public buttonState;
  public notify;

  $onInit() {
    //
  }

  validate() {
    if (this.metrics.june.credits < 44) {
      this.max = this.metrics.june.credits;
    } else {
      this.max = 44;
    }

    // if user has selected value above max, becomes undefined which disables save
    this.buttonState.isDisabled = this.metrics.aug.credits === undefined;
  }
}
